import React from 'react'
import FieldColumn from '../field-column'
import { Field } from 'formik'
import MultiSelectField from '../../form/fields/multi-select'

const IsPrebilledFilterField: React.FC = ({}) => {
  return (
    <FieldColumn>
      <Field
        label="Pré-Facturé"
        name="periodSummary"
        component={MultiSelectField}
        options={[
          {
            label: 'Oui',
            value: true,
          },
          {
            label: 'Non',
            value: false,
          },
        ]}
      />
    </FieldColumn>
  )
}

export default IsPrebilledFilterField
